import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestNgcUserVerification } from "./api";
import { ngcApiKeyAccessKeys } from "./queries";

export function useRequestNgcUserVerificationMutation(email: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => requestNgcUserVerification(),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ngcApiKeyAccessKeys.currentUser(email),
      }),
  });
}
